import { render, staticRenderFns } from "./CPie2.vue?vue&type=template&id=2995a904&scoped=true"
import script from "./CPie2.vue?vue&type=script&lang=js"
export * from "./CPie2.vue?vue&type=script&lang=js"
import style0 from "./CPie2.vue?vue&type=style&index=0&id=2995a904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2995a904",
  null
  
)

export default component.exports